module.exports = __webpack_public_path__ + "media/images/wave2-9617b8c98d71d6ed4559f0e51437d942.png";